import Form from '../lib/forms/Form';
import Field from '../lib/forms/Field';
import MinLengthValidator from '../lib/forms/validators/MinLengthValidator';

export const createForm = ( values = {} ) => new Form( [
	new Field( 'oldPassword', 'Old Password', values.oldPassword, [ new MinLengthValidator( 8 ) ] ),
	new Field( 'password', 'New Password', values.password, [ new MinLengthValidator( 8 ) ] )
] );
